import {
  ReactSelect,
  ReactSelectOption,
} from "@graffer-inc/console-design-kit";
import React, { useEffect } from "react";
import { useState } from "react";
import { SingleValue } from "react-select";
import { useDebouncedCallback } from "use-debounce";

type options = Array<{
  value: string;
  label: string;
}>;

export const AssignedProcedureSelect: React.FC<{
  selectedProcId?: string;
  defaultProcedureOpts: options;
  searchProcedures(
    text: string,
    setOptsCallback: (opts: options) => void,
  ): void;
  onSelect(id?: string): void;
}> = ({ selectedProcId, defaultProcedureOpts, searchProcedures, onSelect }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [opts, setOpts] = useState<options>([]);

  const debounceSearchProcedures = useDebouncedCallback(async (text = "") => {
    if (!text) {
      setOpts(defaultProcedureOpts);
      return;
    }
    setIsLoading(true);
    searchProcedures(text, setOpts);
    setIsLoading(false);
  }, 1000);

  useEffect(() => {
    setOpts(defaultProcedureOpts);
  }, [defaultProcedureOpts]);

  return (
    <ReactSelect
      label=""
      description=""
      isClearable
      placeholder={opts.length === 0 ? "手続き検索中..." : "手続きで絞り込む"}
      value={opts.find((g) => g.value === selectedProcId)}
      onInputChange={(text: string) => {
        debounceSearchProcedures(text);
      }}
      onChange={(v) => {
        const selected = v as SingleValue<ReactSelectOption<string>>;
        onSelect(selected?.value);
      }}
      inputId={"procedure-select"}
      options={opts}
      isLoading={isLoading}
      loadingMessage={() => "手続き検索中..."}
      noOptionsMessage={() => "手続きがありません"}
    />
  );
};
